import { Capacitor } from '@capacitor/core';
import { Injectable } from '@angular/core';
import { Keyboard } from '@capacitor/keyboard';

@Injectable({
  providedIn: 'root'
})
export class KeyboardService {

  constructor() {}

  public disableScroll() {
    Keyboard.setAccessoryBarVisible({ isVisible: false });
    Keyboard.setScroll({ isDisabled: true });
  }

  public enableScroll() {
    Keyboard.setAccessoryBarVisible({ isVisible: true });
    Keyboard.setScroll({ isDisabled: false });
  }

  public hide() {
    if (Capacitor.getPlatform() != "web") {    
      Keyboard.hide();
    }
  }
}
